
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ToasterModule } from '../../../../../components/toaster/toaster.module';
import { ToasterService } from '../../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../../components/toaster/toaster.model';

@Component({
  selector: 'demo-toasters',
  standalone: true,
  imports: [ToasterModule],
  templateUrl: './demo-toasters.component.html',
  styleUrl: './demo-toasters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoToastersComponent {
  constructor(private toasterService: ToasterService) {}

  displayPrimary() {
    this.toasterService.init({
      type: TOASTER_TYPE.PRIMARY,
      title: 'Title',
      content: 'Primary Message',
    });
  }

  displaySuccess() {
    this.toasterService.init({
      type: TOASTER_TYPE.SUCCESS,
      title: 'Title',
      content: 'Success Message',
    });
  }

  displayDanger() {
    this.toasterService.init({
      type: TOASTER_TYPE.DANGER,
      title: 'Title',
      content: 'Danger Message',
    });
  }

  displayWarning() {
    this.toasterService.init({
      type: TOASTER_TYPE.WARNING,
      title: 'Title',
      content: 'Warning Message',
    });
  }

  displayInfo() {
    this.toasterService.init({
      type: TOASTER_TYPE.INFO,
      title: 'Title',
      content: 'Info Message',
    });
  }
}
